module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ordem-servico/ordem-servico.component.css
// module id = ./src/app/ordem-servico/ordem-servico.component.css
// module chunks = main